<ideal-loading-container [loading]="pricingLoading()">
  <div price-info>
    @if (callForPricing()) {
      <ideal-call-for-price-button call-for-price />
    } @else {
      @let priceDetails = mainPrice();
      <div price>{{ priceNormalized() | currency }}</div>
      @if (!hideUnits()) {
        <!-- prettier-ignore -->
        <div per i18n="@@product.units.label">
          {priceDetails.pricePer, plural,
          =1 { {{ priceDetails.pricePer | i18nPlural: unitLabel() }}}
          other { {{ priceDetails.pricePer | number }} {{ priceDetails.pricePer | i18nPlural: unitLabel() }}}
          }
        </div>
      }
      @if (isSaleLimited()) {
        <div limited-sale>Limited Time</div>
      }
    }
  </div>
  <!-- <pre>{{store.isSaleLimited() | json}}</pre> -->
</ideal-loading-container>
